import React, { useState , useRef, useEffect  } from "react";
import ReactDOM from "react-dom";
import { DropdownContainer, DropdownButton, DropdownMenu, DropdownItem } from "../../styles/DropdownComponentsStyle";

interface Role {
  id: string;
  text: string;
}

interface ButtonDropDownProps {
  type: "manage" | "view";
  roles: Role[];
}

const ManageUserRolesMenu: React.FC<ButtonDropDownProps> = ({ type, roles = [] }) => {
  const [isOpen, setIsOpen] = useState(false);
  const buttonRef = useRef<HTMLButtonElement | null>(null);
  const menuRef = useRef<HTMLDivElement | null>(null);
  const [menuStyle, setMenuStyle] = useState<React.CSSProperties>({});

  const filteredRoles = roles.filter((role) =>
    type === "manage"
      ? role.text.toLowerCase().startsWith("manage")
      : role.text.toLowerCase().startsWith("view")
  );

  const buttonText =
    type === "manage"
      ? ` ${filteredRoles.length} Manage Roles `
      : ` ${filteredRoles.length} View Roles`;

  useEffect(() => {
    if (isOpen && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setMenuStyle({
        position: "absolute",
        top: rect.bottom + window.scrollY + 2,
        left: rect.left + window.scrollX,
        zIndex: 1003,
      });
    }
  }, [isOpen]);

  // Add click outside handler
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        isOpen &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target as Node) &&
        menuRef.current &&
        !menuRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <DropdownContainer>
      <DropdownButton
        ref={buttonRef}
        onClick={() => {
          setIsOpen(!isOpen);
        }}
      >
        <span
          className={`circle ${type === "view" ? "lightblue" : "darkblue"}`}
        ></span>
        {buttonText}
      </DropdownButton>

      {isOpen &&
        ReactDOM.createPortal(
          <DropdownMenu ref={menuRef} style={menuStyle}>
            {filteredRoles.map((role) => (
              <DropdownItem key={role.id} roleType={type}>
                {role.text}
              </DropdownItem>
            ))}
          </DropdownMenu>,
          document.body
        )}
    </DropdownContainer>
  );
};

export default ManageUserRolesMenu;
